module.exports = __webpack_public_path__ + "img/add_white.e64b758d.svg";